import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Button } from '@material-ui/core';
import axios from 'Axios';
import Snackbar from 'Snackbar';
import Modal from 'Components/Modal';
import InnerContainer from '../components/InnerContainer';
import Header from '../../Header';
import Footer from '../components/Footer';

class Step4 extends React.Component {
  state = {
    redirectToLogInPage: false,
    finishMessage:
      'You registered successfully! You can now log in with your credentials',
    finishMessageCompany:
      'Your registration request has been submitted for administrator approval. You will be notified by email when your request has been reviewed',
    SnackbarMsg: '',
    openSnackbar: false,
  };

  handleOpenSnackbar = () => {
    this.setState({ openSnackbar: true });
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    if (
      this.props.registrationData.step === 'FINISHED' ||
      this.props.registrationData.type === 'ARUP_REGISTRATION'
    ) {
      this.setState({ redirectToLogInPage: true });
    }
  }

  finishStep = ({ acctok }) => () => {
    axios
      .post('registration/' + acctok, { confirmed: true })
      .then(response => {
        if (response.data) {
          this.setState({ redirectToLogInPage: true });
        }
      })
      .catch(error => {
        this.setState(
          {
            SnackbarMsg: error.response.data.message
              ? error.response.data.message
              : 'Failed to connect to the database',
          },
          this.handleOpenSnackbar
        );
      });
  };

  render() {
    const { step, registrationData, acctok } = this.props;
    const { redirectToLogInPage } = this.state;
    const finishMessage =
      this.props.registrationData.type === 'COMPANY_REGISTRATION'
        ? // || this.props.registrationData.type === 'COMPANY_USER_REGISTRATION'
          this.state.finishMessageCompany
        : this.state.finishMessage;

    if (redirectToLogInPage) {
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { finishMessage },
          }}
        />
      );
    }

    return (
      <React.Fragment>
        <Modal.Header>
          <Header activeStep={step.id} registrationData={registrationData} />
        </Modal.Header>
        <Modal.Body>
          <InnerContainer>
            <p>
              By pressing submit, you are requesting access for your company to
              Luminaire Broker under the Membership Plan as outlined in the
              Luminaire Broker{' '}
              <Link to="/terms-and-conditions" target="_blank">
                Terms of Service
              </Link>
              . Your request will be reviewed by Arup and access granted
              provided your company meets the minimum requirements.
            </p>
            <br />
            <p>
              Luminaire Broker enables you to receive and view luminaire search
              requests from Arup lighting specifiers, to respond to these
              searches with product suggestions, and to communicate with the
              specifiers with a view to matching your products to specific
              project requirements.
            </p>
            <br />
            <p>
              Access to and use of the Luminaire Broker Services shall be
              governed solely by the Luminaire Broker
              <Link to="/terms-and-conditions" target="_blank">
                Terms of Service
              </Link>
              , a copy of which is available here:{' '}
              <Link to="/terms-and-conditions" target="_blank">
                Terms of Service
              </Link>
              .
            </p>
          </InnerContainer>
        </Modal.Body>
        <Modal.Footer>
          <Footer>
            <Button
              onClick={this.finishStep({ acctok })}
              variant="contained"
              color="primary"
            >
              Finish
            </Button>
          </Footer>
        </Modal.Footer>

        <Snackbar
          open={this.state.openSnackbar}
          onClose={this.handleCloseSnackbar}
          msg={this.state.SnackbarMsg}
        />
      </React.Fragment>
    );
  }
}

export default Step4;
